import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { useHistory } from "react-router-dom";

const ForemenManagement = props => {
  document.title = "Foremen Management";
  const location = useLocation();
  const { getRequest, postRequest } = useRequests();
    const history = useHistory();
    React.useEffect(() => {
      if (localStorage.getItem('admin_type') !== 'organization') {
        history.replace('/dashboard');
      }
    }, [history]);
  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [modal_Delete_Foremen, setmodal_Delete_Foremen] = useState(false);
  const [deleteForemenId, setDeleteForemenId] = useState(null);
  const [ForemenData, setForemenData] = useState([]);
  const [ForemenTBody, setForemenTBody] = useState('');
  const [statusModal, setStatusModal] = useState(false);
  const [selectedForemenId, setSelectedForemenId] = useState(null);
  const [status, setStatus] = useState("");
  // For reset password confirmation
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [resetPasswordForemenId, setResetPasswordForemenId] = useState(null);

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

  function Delete_Foremen(f_id) {
    setDeleteForemenId(f_id);
    setmodal_Delete_Foremen(!modal_Delete_Foremen);
  }

  const openStatusModal = (f_id, currentStatus) => {
    setSelectedForemenId(f_id);
    setStatus(currentStatus === "active" ? "inactive" : "active");
    setStatusModal(true);
  };

  const handleChangeStatus = async () => {
    try {
      const jsonpar = JSON.stringify({ f_id: selectedForemenId, status: status });
      const res = await postRequest('update-foremen-status', jsonpar);
      if (res && res.code === 200) {
        setAlertData({ variant: 'success', message: res.message || 'Status updated successfully' });
        handleLoadGetForemen();
      } else {
        setAlertData({ variant: 'error', message: res.message || 'Failed to update status' });
      }
    } catch (error) {
      setAlertData({ variant: 'error', message: 'Something went wrong while updating status' });
    }
    resetAlertData();
    setStatusModal(false);
  };

  const handleDeleteForemen = async () => {
    try {
      const jsonpar = JSON.stringify({ f_id: deleteForemenId });
      const res = await postRequest('delete-foremen', jsonpar);
      if (res && res.code === 200) {
        setAlertData({ variant: 'success', message: res.message });
        setDeleteForemenId(null);
        handleLoadGetForemen();
      } else {
        setAlertData({ variant: 'error', message: res.message || 'Failed to delete foremen' });
      }
    } catch (error) {
      setAlertData({ variant: 'error', message: 'Something went wrong while deleting foremen' });
    }
    resetAlertData();
    setmodal_Delete_Foremen(false);
  };

  // Open reset password confirmation modal
  const openResetPasswordModal = (f_id) => {
    setResetPasswordForemenId(f_id);
    setResetPasswordModal(true);
  };

  // Actually call the API after confirmation
  const handleResetPassword = async () => {
    try {
      const jsonpar = JSON.stringify({ f_id: resetPasswordForemenId });
      const res = await postRequest('reset-foremen-password', jsonpar);
      if (res && res.code === 200) {
        setAlertData({ variant: 'success', message: res.message || 'Password reset successfully' });
      } else {
        setAlertData({ variant: 'error', message: res.message || 'Failed to reset password' });
      }
    } catch (error) {
      setAlertData({ variant: 'error', message: 'Something went wrong while resetting password' });
    }
    resetAlertData();
    setResetPasswordModal(false);
    setResetPasswordForemenId(null);
  };

  const handleT1Body = (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.first_name + " " + element.last_name}</td>
        <td>{element.username || '-'}</td>
        <td>{element.email}</td>
        <td>{element.mobile}</td>
        <td>
          <Button
            className="status-btn"
            color={element.status === "active" ? "success" : "danger"}
            onClick={() => openStatusModal(element.f_id, element.status)}
          >
            {element.status ? element.status.toUpperCase() : ''}
          </Button>
        </td>
        <td className="text-center">
          <div className="centerLink">
            <Link
              title="Edit Foremen"
              to={"/edit_foremen/" + btoa(element.f_id)}
              className="font-size-14 bg-primary edit-box"
            >
              <i className="bx bxs-edit"></i>
            </Link>
            <Link
              title="Delete Foremen"
              to="#"
              className="font-size-14 bg-primary edit-box"
              onClick={() => { Delete_Foremen(element.f_id) }}
            >
              <i className="bx bx-trash"></i>
            </Link>
            <Link
              title="Reset Password"
              to="#"
              className="font-size-14 bg-primary edit-box"
              onClick={() => { openResetPasswordModal(element.f_id) }}
            >
              <i className="bx bx-key"></i>
            </Link>
            <Link
              title="View Crew Members"
              to={`/foremen/${btoa(element.f_id)}/crew`}
              className="font-size-14 bg-primary edit-box"
              style={{ marginLeft: '4px' }}
            >
              <i className="bx bx-group"></i>
            </Link>
          </div>
        </td>
      </tr>
    ));
    setForemenTBody(tempTBody);
  };

  const handleLoadGetForemen = async () => {
    const res = await getRequest('get-foremen');
    if (res && res.code === 200) {
      setForemenData(res.data);
      handleT1Body(res.data);
    } else {
      let tempTBody = (<tr><td colSpan="5" className="text-center">No records found</td></tr>);
      setForemenTBody(tempTBody);
      setAlertData({ variant: 'error', message: res.message });
    }
    resetAlertData();
  };

  React.useEffect(() => {
    handleLoadGetForemen();
    if (location.state && location.state.message) {
      setAlertData({ variant: location.state.status, message: location.state.message });
      resetAlertData();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Foremen Management")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '700px' }}>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ForemenTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">
                      <div className="infoIconBox">
                        <i className="bx bxs-edit"></i>
                        <p>Edit Foremen</p>
                      </div>
                      <div className="infoIconBox">
                        <i className="bx bx-trash"></i>
                        <p>Delete Foremen</p>
                      </div>
                      <div className="infoIconBox">
                        <i className="bx bx-key"></i>
                        <p>Reset Password</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Delete Modal */}
      <Modal isOpen={modal_Delete_Foremen} toggle={() => { Delete_Foremen(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete Foremen</h5>
            <button type="button" onClick={() => { setmodal_Delete_Foremen(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you want to delete this foremen?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={handleDeleteForemen} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_Foremen(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>
      {/* Status Change Modal */}
      <Modal isOpen={statusModal} toggle={() => setStatusModal(!statusModal)} centered>
        <ModalBody>
          <h5>Change Status</h5>
          <p>Are you sure you want to update the status?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setStatusModal(false)}>Cancel</Button>
          <Button color="primary" onClick={handleChangeStatus}>Change Status</Button>
        </ModalFooter>
      </Modal>
      {/* Reset Password Confirmation Modal */}
      <Modal isOpen={resetPasswordModal} toggle={() => setResetPasswordModal(!resetPasswordModal)} centered>
        <ModalBody>
          <h5>Reset Password</h5>
          <p>Are you sure you want to reset the password for this foremen?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setResetPasswordModal(false)}>Cancel</Button>
          <Button color="primary" onClick={handleResetPassword}>Reset Password</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(ForemenManagement);
